export default {
  rfl: 'rfl',
  commercial: 'commercial'
};
